const state = {
  returnOrderState: [
    {
      label: "待商家审核",
      value: "INITIAL",
    },
    {
      label: "待填写物流信息",
      value: "SUPPLIER_APPROVED",
    },
    {
      label: "待商家收货",
      value: "SHIPPED",
    },
    {
      label: "待退款",
      value: "CONFIRMED",
    },
    {
      label: "已完成",
      value: "COMPLETED",
    },
    {
      label: "拒绝收货",
      value: "SHIPPED_REJECTED",
    },
    {
      label: "拒绝退款",
      value: "REFUSED_REFUND",
    },
    {
      label: "已取消",
      value: "INVALID",
    },
    {
      label: "退款失败",
      value: "CLOSED",
    },
  ],
  returnOrderServerType: [
    {
      label: "我要退款（无需退货）",
      value: "REFUND",
    },
    {
      label: "我要退货退款",
      value: "RETURNS_AND_REFUNDS",
    },
  ],
  returnOrderGoodsState: [
    {
      label: "未按约定时间发货",
      value: "NOT_YET_SHIPPED",
    },
    {
      label: "未收货",
      value: "RECEIVED_GOODS",
    },
  ],
  returnOrderAppealReason: [
    {
      label: "不喜欢/不想要",
      value: "DISLIKE",
    },
    {
      label: "空包裹",
      value: "AIR_PARCEL",
    },
    {
      label: "未按约定时间发货",
      value: "FAIL_DELIVER_GOODS_ON_TIME",
    },
    {
      label: "物流/快递一直未送到",
      value: "DELIVERY_NEVER_ARRIVED",
    },
    {
      label: "物流/快递无跟踪记录",
      value: "NO_TRACKING_RECORD_OF_DELIVERY",
    },
    {
      label: "货物破损已拒签",
      value: "BAD_ORDER_REJECTED",
    },
  ],
  financialType: [
    {
      label: "分销佣金",
      value: "DISTRIBUTION_COMMISSION",
    },
    {
      label: "佣金提现",
      value: "COMMISSION_WITHDRAWAL",
    },
    {
      label: "团队奖励",
      value: "TEAM_REWARDS",
    },
    {
      label: "佣金提成",
      value: "COMMISSION",
    },
    {
      label: "余额支付",
      value: "BALANCE_PAY",
    },
    {
      label: "余额退款",
      value: "BALANCE_PAY_REFUND",
    },
    {
      label: "创建红包",
      value: "CREATE_RED_PACK",
    },
    {
      label: "赔偿红包",
      value: "COMPENSATE",
    },
    {
      label: "现金红包",
      value: "AWARD_REWARDS"
    },
    {
      label: "培训奖励",
      value: "TRAINING_REWARD"
    }
  ],
  inSaleOrderState: [
    {
      label: "待支付",
      value: "INITIAL",
    },
    {
      label: "待发货",
      value: "PAID",
    },

    {
      label: "待收货",
      value: "SHIPPED",
    },

    {
      label: "已完成",
      value: "COMPLETED",
    },

    {
      label: "已关闭",
      value: "CLOSED",
    },
  ],
};

export default {
  namespaced: true,
  state,
};
